import {RoutingModel} from "../../common/models/routing";
import RouteSwitch from "../../helpers/routeSwitch";
import LightBoardList from "../components/lightBoardList/lightBoardList";
import {UserRoles} from "../../helpers/userRoles";
import FerryOrdersParkingList from "../components/parkingsLists/ferryOrdersParkingList/ferryOrdersParkingList";
import PlaceOwnedVehicleList from "../components/placeOwnedVehicleList/placeOwnedVehicleList";
import EntryOrExitList from "../components/entryOrExitList/entryOrExitList";
import NonFerryOrdersParkingList from "../components/parkingsLists/nonFerryParkingList/nonFerryOrdersParkingList";

enum lightBoardsRoutingAddress {
    lightBoards = "/place/lightBoards",
    list = "/place/lightBoards/list",
}

enum ownedVehiclesRoutingAddress {
    ownedVehicles = "/place/ownedVehicles",
    list = "/place/ownedVehicles/list",
}

enum ferryOrdersParkingsRoutingAddress {
    ferryOrdersParkings = "/place/ferryOrders/parkings",
    list = "/place/ferryOrders/parkings/list",
}

enum nonFerryOrdersParkingsRoutingAddress {
    nonFerryOrdersParkings = "/place/nonFerryOrders/parkings",
    list = "/place/nonFerryOrders/parkings/list",
}

enum entryOrExitRoutingAddeess {
    entryOrExit = "/place/entryOrExit",
    list = "/place/entryOrExit/list"
}

export const placeRoutingAddress = {
    lightBoards: lightBoardsRoutingAddress,
    ownedVehicles: ownedVehiclesRoutingAddress,
    ferryOrdersParkings: ferryOrdersParkingsRoutingAddress,
    nonFerryOrdersParkings: nonFerryOrdersParkingsRoutingAddress,
    entryOrExit: entryOrExitRoutingAddeess
};

export const placeRoutes: RoutingModel[] = [
    {
        path: placeRoutingAddress.lightBoards.lightBoards,
        component: RouteSwitch,
        routes: [
            {
                path: placeRoutingAddress.lightBoards.list,
                component: LightBoardList,
                roles: [UserRoles.lightBoardsViewAndModification]
            }
        ]
    },
    {
        path: placeRoutingAddress.ownedVehicles.ownedVehicles,
        component: RouteSwitch,
        routes: [
            {
                path: placeRoutingAddress.ownedVehicles.list,
                component: PlaceOwnedVehicleList,
                roles: [UserRoles.ownedVehiclesView]
            }
        ]
    },
    {
        path: placeRoutingAddress.ferryOrdersParkings.ferryOrdersParkings,
        component: RouteSwitch,
        routes: [
            {
                path: placeRoutingAddress.ferryOrdersParkings.list,
                component: FerryOrdersParkingList,
                roles: [UserRoles.parkingsView]
            }
        ]
    },
    {
        path: placeRoutingAddress.nonFerryOrdersParkings.nonFerryOrdersParkings,
        component: RouteSwitch,
        routes: [
            {
                path: placeRoutingAddress.nonFerryOrdersParkings.list,
                component: NonFerryOrdersParkingList,
                roles: [UserRoles.parkingsView]
            }
        ]
    },
    {
        path: placeRoutingAddress.entryOrExit.entryOrExit,
        component: RouteSwitch,
        routes: [
            {
                path: placeRoutingAddress.entryOrExit.list,
                component: EntryOrExitList,
                roles: [UserRoles.entryExitViewAndModification]
            }
        ]
    },
];
